<template>
  <div class="userAgreement"  v-bind:class="{ 'desktop': $isDesktop }">
    <PopupHeader theme="light" title="Kullanıcı sözleşmesi" :logoActive="false" @clicked='formClose' />
    <div class='divider'></div>
    <div v-if="userAgreementText.length > 0" class='info-text' v-html="userAgreementText[4].Body"></div>
   </div>
</template>
<script>
import service from '@/service'
import PopupHeader from '@/shared/widget/popupHeader'
export default {
  name: 'UserAgreement',
  components: {
    PopupHeader
  },
  data () {
    return {
      userAgreementText: []
    }
  },
  mounted () {
    var self = this
    service.content.userAgreement(self).then(function (response) {
      if (response === null) return
      self.userAgreementText = response.data.pagecategories[0].pages
    })
  },
  methods: {
    formClose () {
      this.$emit('closePanel')
    }
  }
}
</script>

<style scoped>
  .userAgreement.desktop {
      padding: 135px 29%;
  }
  
  .userAgreement.desktop .info-text {
    background-color: var(--light-bg1);
  }

  .userAgreement.desktop .info-text >>> .info-text-detail-paragraph {
    margin: 0em 1.875em 1.875em 1.875em;
  }

  .info-text {
      background-color: var(--light-bg2);
      height: 100%;
      padding: 5px;
  }

  .info-text >>> .info-text-detail-paragraph {
    font-size: 14px;
    line-height: 1.43;
    letter-spacing: normal;
    color: var(--text-color1);
    margin:5em 0.9375em 1em 0.9375em;
  }

  .info-text-subTitle {
    font-weight: 600;
    letter-spacing: -0.4px;
    color: var(--text-color5);
    margin: 0 0.9375em;
  }
</style>
<style>

</style>


// WEBPACK FOOTER //
// src/shared/widget/legalInfo/UserAgreement.vue